export default {
  allMsg: 'Tutti i messaggi',
  systemMsg: 'Messaggi di sistema',
  personMsg: 'Messaggi manuali',
  unread: 'Non letto',
  seeDetail: 'Vedi dettagli',
  read: 'Letto',
  replyNow: 'Rispondi ora',
  message: 'Messaggio',
  operateSuccess: 'Operazione riuscita',
  holder: {
    searchHolder: 'N. pacco/N. ordine/N. articolo',
  },
  addAcBuy: 'Unisciti ad AcBuy Discord e vinci 2000 ¥ in CASH!',
  joinNow: 'Unisciti qui',
  flatActivity: 'Condividi la tua esperienza di acquisto su Taobao & AcBuy — Vinci 1500 ¥ in CASH!',
  joinNow1: 'Unisciti ora',
  tips1: 'Giveaway ufficiale di Labubu di Acbuy',
  tips2: 'Grande giveaway di Labubu e set completo ZIMOMO',
}
